import { useMemo } from 'react';
import { useUpdateSolutionViewerWaterTreatmentAccessMutation } from '../api';
/**
 * Hook to update a user's solution viewer water treatment access.
 *
 * @returns a mutation function to update solution viewer water treatment access.
 */
export const useUpdateSolutionViewerWaterTreatmentAccess = () => {
    const [updateSolutionViewerWaterTreatmentAccess, { isLoading, isError, error }] = useUpdateSolutionViewerWaterTreatmentAccessMutation();
    return useMemo(() => ({
        updateSolutionViewerWaterTreatmentAccess,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, updateSolutionViewerWaterTreatmentAccess]);
};
